import { useEffect } from "react";
import { decodeJwt, setCookie } from "@/utils/cookieUtils";
import posthog from "posthog-js";
import { useUser } from "@/context/UserContext";

const Auth = () => {
  const { setUserInfo } = useUser();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) {
      try {
        // Store the token in a cookie
        setCookie("jwt", token);
        const decoded = decodeJwt(token);
        const { address, email, id, name, waitlisted } = decoded;
        const hasWallet = window.ethereum ? true : false;
        setUserInfo({
          id: id,
          name: name,
          email: email,
          address: address,
          has_wallet: hasWallet,
          waitlisted: waitlisted,
        });
        posthog.identify(address, {
          email: email,
          name: name,
          has_wallet: hasWallet,
          waitlisted: waitlisted,
        });
      } catch (err) {
        console.error("Error storing token or checking role:", err);
      }
    } else {
      window.location.href = "/";
    }
  }, [setUserInfo]);

  return <></>;
};

export default Auth;
